import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConfigService } from '../../../../core';
import { ConfigPedido } from '../../../../home/configuracoes/app/pedido/config-pedido';
import { ConfigPedidoUtilsService } from '../../../../home/configuracoes/app/pedido/services/config-pedido-utils.service';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { getStatusConfig } from './constants';

export interface IStatus {
  [key: string]: boolean;
}

@Component({
  selector: 'sgt-novo-pedido-status-multi-select',
  templateUrl: './novo-pedido-status-multi-select.component.html',
  styleUrls: ['./novo-pedido-status-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoPedidoStatusMultiSelectComponent),
      multi: true
    }
  ]
})
export class NovoPedidoStatusMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  configPedido: ConfigPedido;

  @Input() idsPedidoStatus: number[];
  @Input() variante: 'filtro' | undefined;
  @Input() icon = 'fa-clipboard-check';

  private status: IStatus = {
    hasNaoConfirmado: true,
    hasNaoLiberado: true,
    hasConfirmado: true,
    hasEmAnalise: true,
    hasAprovado: true,
    hasReprovado: true,
    hasProducao: true,
    hasFaturado: true,
    hasFaturadoParcial: true,
    hasConfirmandoERP: true,
    hasAbertoERP: true,
    hasOutro: true,
    hasCancelado: true
  };

  @Output() idsPedidoStatusChange = new EventEmitter<number[]>();

  options: IOption[] = [];
  settings: IMultiSelectSettings = {
    placeholder: 'Status do Pedido',
    singular: 'Status do Pedido',
    plural: 'Status do Pedido',
    searchEmptyResultMessage: 'Nenhum status do pedido encontrado',
    showFooter: true
  };

  constructor(
    private configService: ConfigService,
    private configPedidoUtilsService: ConfigPedidoUtilsService
  ) {
    super();
  }

  ngOnInit() {
    this.configPedido = this.configService.getPedido();
    this.createPedidoStatus();
  }


  private createPedidoStatus() {
    const statusConfig = getStatusConfig(this.status);

    this.options = statusConfig
      .filter((config) =>
        config.show &&
        this.configPedidoUtilsService.possuiStatus(
          this.configPedido,
          config.status
        )
      )
      .map((config) => ({
        id: config.status.id,
        label: config.status.nome,
        isChecked: false,
        cssClass: config.cssClass
      }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsPedidoStatus = newValue || [];
  }

  onSelectionChange(): void {
    this.emitChange(this.idsPedidoStatus);
  }

  onSearch() {
    this.idsPedidoStatusChange.emit(this.idsPedidoStatus);
  }
}
